import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, vShow as _vShow, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/gifs/Aguarde.gif'


const _withScopeId = n => (_pushScopeId("data-v-02d0ac18"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "currentColor",
  class: "bi bi-person-badge me-2",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M4.5 0A2.5 2.5 0 0 0 2 2.5V14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2.5A2.5 2.5 0 0 0 11.5 0h-7zM3 2.5A1.5 1.5 0 0 1 4.5 1h7A1.5 1.5 0 0 1 13 2.5v10.795a4.2 4.2 0 0 0-.776-.492C11.392 12.387 10.063 12 8 12s-3.392.387-4.224.803a4.2 4.2 0 0 0-.776.492V2.5z" })
], -1))
const _hoisted_2 = { class: "d-flex row colunaDados" }
const _hoisted_3 = { class: "form-label col-12 col-sm-12 col-md-12 col-lg-2 col-xl-1 col-xxl-1" }
const _hoisted_4 = { class: "form-label col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3 col-xxl-3" }
const _hoisted_5 = { class: "form-label col-12 col-sm-12 col-md-12 col-lg-3 col-xl-2 col-xxl-2" }
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_8 = {
  class: "d-flex prontuario",
  style: { 'height': 'auto' }
}
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = { class: "d-flex informacoesProntuarios scrollspy-example w-100" }
const _hoisted_11 = {
  class: "me-0 h-50 tabelaInformacoes w-100",
  style: { 'minHeight': '200px' }
}
const _hoisted_12 = { class: "table mb-0" }
const _hoisted_13 = { class: "linhaCabecalho" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["id", "onClick", "onKeyup", "tabindex"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = ["tabindex"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "2" }, "Nenhum prontuário encontrado")
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "me-0 scrollspy-example h-50 informacoesDetalhadas" }
const _hoisted_24 = { class: "d-flex flex-direction-row justify-content-between" }
const _hoisted_25 = { class: "form-label col-sm-5 col-md-5 col-5" }
const _hoisted_26 = { class: "form-label col-sm-5 col-md-5 col-5" }
const _hoisted_27 = ["value"]
const _hoisted_28 = {
  key: 1,
  class: "form-control",
  type: "text",
  disabled: "",
  value: ''
}
const _hoisted_29 = { class: "form-label col-sm-12 col-md-12 col-12" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "camposProntuario me-0" }
const _hoisted_32 = { class: "nav nav-tabs abas" }
const _hoisted_33 = { class: "nav-item" }
const _hoisted_34 = { class: "nav-item" }
const _hoisted_35 = { class: "nav-item" }
const _hoisted_36 = { class: "nav-item" }
const _hoisted_37 = { class: "nav-item" }
const _hoisted_38 = { class: "nav-item" }
const _hoisted_39 = { class: "col-sm-12 col-md-12 form-label h-auto" }
const _hoisted_40 = { class: "col-sm-12 col-md-12 form-label h-auto" }
const _hoisted_41 = { class: "col-sm-12 col-md-12 form-label h-auto" }
const _hoisted_42 = { class: "col-sm-12 col-md-12 form-label h-auto" }
const _hoisted_43 = { class: "col-sm-12 col-md-12 form-label h-auto" }
const _hoisted_44 = { class: "receitasPequena mb-5" }
const _hoisted_45 = { class: "col-sm-5 col-md-5 form-label" }
const _hoisted_46 = { class: "nav nav-tabs" }
const _hoisted_47 = { class: "nav-item" }
const _hoisted_48 = { class: "nav-link active" }
const _hoisted_49 = { class: "col-sm-5 col-md-5 form-label" }
const _hoisted_50 = { class: "nav nav-tabs" }
const _hoisted_51 = { class: "nav-item" }
const _hoisted_52 = { class: "nav-link active" }
const _hoisted_53 = { class: "modal-footer px-0 pb-0" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "imagem" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "imagemTamanho",
    src: _imports_0,
    alt: ""
  })
], -1))

import { computed, onMounted, reactive } from 'vue';
import PacienteProntuario from '@/model/PacienteProntuario';
import ModalDorape from '@/components/ModalDorape.vue';
import { TipoMensagem } from '@/consts/consts';
import Padrao from '@/components/Padrao.vue';
import mensagem from '@/hooks/mensagem';
import Paciente from '@/model/Paciente';
import services from '@/services';
import { store } from '@/store';
import moment from 'moment';
import router from '@/router';
import Profissional from '@/model/Profissional';
import Convenio from '@/model/Convenio';
import ProntuarioComp from '@/components/ProntuarioComp.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProntuarioView',
  props: ['maiusculo', 'retornaPossuiPermissao', 'retornaDataBR', 'retornaIdVDatePicker', 'retornaDataUSA'],
  setup(__props) {

const props = __props;



const msg = mensagem();

const state = reactive({
    linhas: Array<string>('id', 'nome'),
    colunas: Array<string>('Código', 'Nome'),
    linhasAux: Array<string>('data', 'profissional'),
    colunasAux: Array<string>('Data', 'Profissional'),
    lstPacientes: Array<Paciente>(),
    lstProntuarios: Array<PacienteProntuario>() as any,

    mostrarModal: Boolean(),
    campoUnico: Boolean(),
    telaPequena: Boolean(true),
    aguarde: Boolean(),

    paciente: Object() as Paciente,
    prontuario: {
        id: Number(),
        paciente: Object() as Paciente,
        profissional: Object() as Profissional,
        convenio: Object() as Convenio,
        idAtendimento: Number(),
        data: new Date(),
        hora: String(),
        usuario: String(),
        tipo: String(),
        hda: String(),
        hdaEnfermagem: String(),
        diagnostico: String(),
        exameFisico: String(),
        receita: String(),
        receitaEspecial: String(),
        lancouTelaPadrao: String(),
        idAtendimentoEv: Number(),
    },
    agendaLancar: {
        id: Number(),
        dtInclusao: new Date(),
        dtAgenda: new Date(),
        hrInclusao: new Date().toLocaleTimeString(),
        hrAgenda: String(),
        hrChegada: null,
        usuario: String(),
        usuarioUpdate: String(),
        status: String(),
        convenio: Object() as Convenio,
        profissional: Object() as Profissional,
        paciente: Object() as Paciente,
        idResumo: Number(),
        idAgendaPrincipal: Number(),
        idAtendimento: Number(),
        ordemChegada: Number(),
        whatsConfirmacao: String(),
        nomePaciente: String(),
        celular: String(),
        telefone: String(),
        idCliente: Number(),
        statusDescricao: String(),
        idPaciente: Number()
    },

    hdaMedico: "HDA Médico",
    hdaEnfermagem: "HDA Enfermagem",
    exameFisico: "Exame Físico",
    diagnostico: "Diagnóstico",
    receita: "Receita",
    receitaEspecial: "Receita Especial",

    numeroPagina: Number(0),
    linhaFocada: Number(0),
});

function tamanho() {
    setInterval(() => {
        (window.innerWidth <= 992) ? state.telaPequena = true : state.telaPequena = false;
        // (window.innerWidth <= 768) ? state.telaPequena = true : state.telaPequena = false;
    }, 100);
}

async function abrirModalProntuario(pObj: any) {
    state.aguarde = true;
    let data;
    state.lstProntuarios = [];
    state.prontuario = {
        id: Number(),
        paciente: Object() as Paciente,
        profissional: Object() as Profissional,
        convenio: Object() as Convenio,
        idAtendimento: Number(),
        data: new Date(),
        hora: String(),
        usuario: String(),
        tipo: String(),
        hda: String(),
        hdaEnfermagem: String(),
        diagnostico: String(),
        exameFisico: String(),
        receita: String(),
        receitaEspecial: String(),
        lancouTelaPadrao: String(),
        idAtendimentoEv: Number(),
    };
    state.paciente = pObj;
    // console.log(pObj);
    // (usuario.value.login == "master") ?
    data = await services.pacienteProntuario.ListarPorIdPaciente(state.paciente.id);
    // :
    // data = await services.pacienteProntuario.ListarPorIdPaciente(usuario.value.id);
    if (!data.erros) {
        state.lstProntuarios = data.data;
        if (state.lstProntuarios.length) {
            state.prontuario = state.lstProntuarios[0];
            document.getElementById("prontuario0")?.click();
            movimentacaoSeta(0);
        }
        // document.querySelector('html')?.classList.add("desligarOverflow");
        state.mostrarModal = true;
    } else {
        msg.InserirMensagem('Erro', data.erros.statusText, TipoMensagem.Error);
    }
    state.aguarde = false;
}

function modalResultProntuarios(result: string) {
    if (result == "ok") { /* console.log("ok");*/ }
    state.mostrarModal = false;
    document.querySelector('html')?.classList.remove("overflow-hidden");
}

async function selecionarProntuario(pParam: any, pIndex: number) {
    // console.log(pParam);
    // let sql = `SELECT ID_CONVENIO FROM AGENDAMENTO WHERE ID = ${pParam.id}`;
    // let data = await services.relatorio.ListarSql(sql);
    // console.log(sql);
    // if (!data.erros) {
    //     data = await services.convenio.ListarPorId(data.data);
    //     console.log(data);
    //     if (!data.erros) {
    //         state.prontuario.convenio = data.data;
    //     }
    // }
    state.linhaFocada = pIndex;
    state.prontuario = pParam;
}

// function retornaNomeProfissional(pParam: any) {
//     if (pParam.profissional) {
//         return pParam.profissional.nome; //Refatorar
//     }
// }

function trocarPagina(pPagina: number) {
    state.numeroPagina = pPagina;
}

function movimentacaoSeta(pParam: number) {
    selecionarProntuario(state.lstProntuarios[pParam], pParam);
    document.getElementById(`prontuario${pParam}`)?.focus();
}

function moverPorSeta(pIndice: number, event?: KeyboardEvent) {
    if (event?.key == "ArrowUp" || event?.key == "ArrowLeft") {
        (pIndice - 1 < 0) ? movimentacaoSeta(state.lstProntuarios.length - 1) : movimentacaoSeta(pIndice - 1);
    } else if (event?.key == "ArrowDown" || event?.key == "ArrowRight") {
        (pIndice + 1 > state.lstProntuarios.length - 1) ? movimentacaoSeta(0) : movimentacaoSeta(pIndice + 1);
    }
}

const config = computed(() => {
    return store.getters.getConfig;
});

const profissional = computed(() => {
    return store.getters.getProfissional;
});

// const usuario = computed(() => {
//     return store.getters.getUsuario;
// });

onMounted(() => {
    setTimeout(() => {
        (config.value.prontCampo1Visible && config.value.prontCampo1.trim() != "") ? state.hdaMedico = config.value.prontCampo1 : "";
        if (config.value.prontCampoUnico == true) {
            state.campoUnico = config.value.prontCampoUnico;
        } else {
            (config.value.prontCampoEnfVisible && config.value.prontCampoEnf.trim() != "") ? state.hdaEnfermagem = config.value.prontCampoEnf : "";
            (config.value.prontCampo2Visible && config.value.prontCampo2.trim() != "") ? state.exameFisico = config.value.prontCampo2 : "";
            (config.value.prontCampo3Visible && config.value.prontCampo3.trim() != "") ? state.diagnostico = config.value.prontCampo3 : "";
            (config.value.prontCampo4Visible && config.value.prontCampo4.trim() != "") ? state.receita = config.value.prontCampo4 : "";
            (config.value.prontCampo5Visible && config.value.prontCampo5.trim() != "") ? state.receitaEspecial = config.value.prontCampo5 : "";
        }
        // console.log(config.value);
    }, 500);
    // router.afterEach(() => {
    // });    
    tamanho();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Padrao, {
      titulo: "Prontuário",
      linhas: state.linhas,
      colunas: state.colunas,
      dados: state.paciente,
      url: 'Paciente',
      linhasAux: state.linhasAux,
      colunasAux: state.colunasAux,
      onAbrirModal: abrirModalProntuario,
      tabela: "PACIENTE",
      campoPorId: "id?id",
      distinct: true,
      tabelasJoin: 'PACIENTE_PRONTUARIO'
    }, {
      icone: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["linhas", "colunas", "dados", "linhasAux", "colunasAux"]),
    (state.mostrarModal)
      ? (_openBlock(), _createBlock(ModalDorape, {
          key: 0,
          title: "Informações Adicionais",
          visible: state.mostrarModal,
          usarFooter: false,
          usarModal: true,
          larguraMaxima: '95%',
          onModalResult: modalResultProntuarios
        }, _createSlots({ _: 2 }, [
          (state.lstProntuarios)
            ? {
                name: "default",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("label", _hoisted_3, [
                      _createTextVNode("Código "),
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        disabled: "",
                        type: "text",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.paciente.id) = $event))
                      }, null, 512), [
                        [_vModelText, state.paciente.id]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_4, [
                      _createTextVNode("Nome "),
                      (state.paciente.nomeSocial?.trim().length > 0)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            class: "form-control",
                            disabled: "",
                            type: "text",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.paciente.nomeSocial) = $event))
                          }, null, 512)), [
                            [_vModelText, state.paciente.nomeSocial]
                          ])
                        : _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 1,
                            class: "form-control",
                            disabled: "",
                            type: "text",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.paciente.nome) = $event))
                          }, null, 512)), [
                            [_vModelText, state.paciente.nome]
                          ])
                    ]),
                    _createElementVNode("label", _hoisted_5, [
                      _createTextVNode("Data de Nascimento "),
                      _createElementVNode("input", {
                        class: "form-control",
                        disabled: "",
                        type: "text",
                        value: __props.retornaDataBR(state.prontuario.paciente.dtNascimento)
                      }, null, 8, _hoisted_6)
                    ])
                  ]),
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("table", _hoisted_12, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", _hoisted_13, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.colunasAux, (c, index) => {
                                  return (_openBlock(), _createElementBlock("th", {
                                    key: index,
                                    class: _normalizeClass(`linha cabecalho pointer`)
                                  }, _toDisplayString(c), 1))
                                }), 128))
                              ])
                            ]),
                            (state.lstProntuarios.length > 0)
                              ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.lstProntuarios, (p, index) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: index,
                                      id: `prontuario${index}`,
                                      onClick: ($event: any) => (selecionarProntuario(p, index)),
                                      onKeyup: ($event: any) => (moverPorSeta(index, $event)),
                                      class: _normalizeClass({ 'table-active fonte': index === state.linhaFocada }),
                                      style: { 'cursor': 'default' },
                                      tabindex: index + 1
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.linhasAux, (l, index) => {
                                        return (_openBlock(), _createElementBlock("td", {
                                          key: index,
                                          class: "linha"
                                        }, [
                                          _withDirectives(_createElementVNode("span", null, _toDisplayString(_unref(moment)(p[l]).format('DD/MM/YYYY')), 513), [
                                            [_vShow, typeof p[l] === 'string' && p[l].includes('T00:00:00')]
                                          ]),
                                          (typeof p[l] === 'object' && p[l]?.descricao)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(p[l]?.descricao), 1))
                                            : (typeof p[l] === 'object' && p[l]?.nome)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(p[l]?.nome), 1))
                                              : ((typeof p[l] === 'object'))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, " NÃO INFORMADO "))
                                                : _createCommentVNode("", true),
                                          _withDirectives(_createElementVNode("span", null, _toDisplayString(p[l]), 513), [
                                            [_vShow, (typeof p[l] !== 'string' || !p[l].includes('T00:00:00'))
                                                && !p[l]?.descricao && !p[l]?.nome]
                                          ])
                                        ]))
                                      }), 128))
                                    ], 42, _hoisted_15))
                                  }), 128)),
                                  _createElementVNode("tr", {
                                    tabindex: state.lstProntuarios.length + 1,
                                    onKeyup: _cache[3] || (_cache[3] = ($event: any) => (moverPorSeta(state.lstProntuarios.length + 1, $event)))
                                  }, null, 40, _hoisted_19)
                                ]))
                              : (_openBlock(), _createElementBlock("tbody", _hoisted_20, _hoisted_22))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("label", _hoisted_25, [
                            _createTextVNode("Código "),
                            _withDirectives(_createElementVNode("input", {
                              class: "form-control",
                              type: "text",
                              disabled: "",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.prontuario.id) = $event))
                            }, null, 512), [
                              [_vModelText, state.prontuario.id]
                            ])
                          ]),
                          _createElementVNode("label", _hoisted_26, [
                            _createTextVNode("Data "),
                            (state.prontuario.id > 0)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  class: "form-control",
                                  type: "text",
                                  disabled: "",
                                  value: __props.retornaDataBR(state.prontuario.data)
                                }, null, 8, _hoisted_27))
                              : (_openBlock(), _createElementBlock("input", _hoisted_28))
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_29, [
                          _createTextVNode("Profissional "),
                          _createElementVNode("input", {
                            class: "form-control",
                            type: "text",
                            disabled: "",
                            value: state.prontuario.profissional?.nome
                          }, null, 8, _hoisted_30)
                        ])
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_31, [
                      _createElementVNode("ul", _hoisted_32, [
                        _createElementVNode("li", _hoisted_33, [
                          _createElementVNode("button", {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (trocarPagina(0))),
                            class: _normalizeClass(["nav-link", { 'active': state.numeroPagina === 0, 'texto-colorido': state.numeroPagina != 0 }])
                          }, _toDisplayString(state.hdaMedico), 3)
                        ]),
                        _createElementVNode("li", _hoisted_34, [
                          _withDirectives(_createElementVNode("button", {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (trocarPagina(1))),
                            class: _normalizeClass(["nav-link", { 'active': state.numeroPagina === 1, 'texto-colorido': state.numeroPagina != 1 }])
                          }, _toDisplayString(state.hdaEnfermagem), 3), [
                            [_vShow, state.campoUnico === false]
                          ])
                        ]),
                        _createElementVNode("li", _hoisted_35, [
                          _withDirectives(_createElementVNode("button", {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (trocarPagina(2))),
                            class: _normalizeClass(["nav-link", { 'active': state.numeroPagina === 2, 'texto-colorido': state.numeroPagina != 2 }])
                          }, _toDisplayString(state.exameFisico), 3), [
                            [_vShow, state.campoUnico === false]
                          ])
                        ]),
                        _createElementVNode("li", _hoisted_36, [
                          _withDirectives(_createElementVNode("button", {
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (trocarPagina(3))),
                            class: _normalizeClass(["nav-link", { 'active': state.numeroPagina === 3, 'texto-colorido': state.numeroPagina != 3 }])
                          }, _toDisplayString(state.diagnostico), 3), [
                            [_vShow, state.campoUnico === false]
                          ])
                        ]),
                        _createElementVNode("li", _hoisted_37, [
                          _withDirectives(_createElementVNode("button", {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (trocarPagina(4))),
                            class: _normalizeClass(["nav-link", { 'active': state.numeroPagina === 4, 'texto-colorido': state.numeroPagina != 4 }])
                          }, _toDisplayString(state.receita), 3), [
                            [_vShow, state.campoUnico === false]
                          ])
                        ]),
                        _createElementVNode("li", _hoisted_38, [
                          _withDirectives(_createElementVNode("button", {
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (trocarPagina(5))),
                            class: _normalizeClass(["nav-link", { 'active': state.numeroPagina === 5, 'texto-colorido': state.numeroPagina != 5 }])
                          }, _toDisplayString(state.receitaEspecial), 3), [
                            [_vShow, state.campoUnico === false]
                          ])
                        ])
                      ]),
                      _withDirectives(_createElementVNode("label", {
                        class: _normalizeClass(["col-sm-12 col-md-12 form-label", { 'h-auto': state.campoUnico === false, 'campoUnico': state.campoUnico === true }])
                      }, [
                        _withDirectives(_createElementVNode("textarea", {
                          disabled: "",
                          class: "form-control h-100 w-100",
                          cols: "63",
                          rows: "8",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((state.prontuario.hda) = $event))
                        }, null, 512), [
                          [_vShow, state.campoUnico == false],
                          [_vModelText, state.prontuario.hda]
                        ]),
                        _withDirectives(_createElementVNode("textarea", {
                          disabled: "",
                          class: "form-control h-100 w-100",
                          cols: "63",
                          rows: "8",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((state.prontuario.hda) = $event))
                        }, null, 512), [
                          [_vShow, state.campoUnico == true],
                          [_vModelText, state.prontuario.hda]
                        ])
                      ], 2), [
                        [_vShow, state.numeroPagina === 0]
                      ]),
                      _withDirectives(_createElementVNode("label", _hoisted_39, [
                        _withDirectives(_createElementVNode("textarea", {
                          disabled: "",
                          class: "form-control h-100 w-100",
                          cols: "63",
                          rows: "8",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((state.prontuario.hdaEnfermagem) = $event))
                        }, null, 512), [
                          [_vModelText, state.prontuario.hdaEnfermagem]
                        ])
                      ], 512), [
                        [_vShow, state.numeroPagina === 1 && state.campoUnico === false]
                      ]),
                      _withDirectives(_createElementVNode("label", _hoisted_40, [
                        _withDirectives(_createElementVNode("textarea", {
                          disabled: "",
                          class: "form-control h-100 w-100",
                          cols: "63",
                          rows: "8",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((state.prontuario.exameFisico) = $event))
                        }, null, 512), [
                          [_vModelText, state.prontuario.exameFisico]
                        ])
                      ], 512), [
                        [_vShow, state.numeroPagina === 2 && state.campoUnico === false]
                      ]),
                      _withDirectives(_createElementVNode("label", _hoisted_41, [
                        _withDirectives(_createElementVNode("textarea", {
                          disabled: "",
                          class: "form-control h-100 w-100",
                          cols: "63",
                          rows: "8",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((state.prontuario.diagnostico) = $event))
                        }, null, 512), [
                          [_vModelText, state.prontuario.diagnostico]
                        ])
                      ], 512), [
                        [_vShow, state.numeroPagina === 3 && state.campoUnico === false]
                      ]),
                      _withDirectives(_createElementVNode("label", _hoisted_42, [
                        _withDirectives(_createElementVNode("textarea", {
                          disabled: "",
                          class: "form-control h-100",
                          cols: "63",
                          rows: "8",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((state.prontuario.receita) = $event))
                        }, null, 512), [
                          [_vModelText, state.prontuario.receita]
                        ])
                      ], 512), [
                        [_vShow, state.numeroPagina === 4]
                      ]),
                      _withDirectives(_createElementVNode("label", _hoisted_43, [
                        _withDirectives(_createElementVNode("textarea", {
                          disabled: "",
                          class: "form-control h-100",
                          cols: "63",
                          rows: "8",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((state.prontuario.receitaEspecial) = $event))
                        }, null, 512), [
                          [_vModelText, state.prontuario.receitaEspecial]
                        ])
                      ], 512), [
                        [_vShow, state.numeroPagina === 5]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_44, [
                        _createElementVNode("label", _hoisted_45, [
                          _createElementVNode("ul", _hoisted_46, [
                            _createElementVNode("li", _hoisted_47, [
                              _createElementVNode("span", _hoisted_48, _toDisplayString(state.receita), 1)
                            ])
                          ]),
                          _withDirectives(_createElementVNode("textarea", {
                            class: "form-control",
                            disabled: "",
                            cols: "1",
                            rows: "6",
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((state.prontuario.receita) = $event))
                          }, null, 512), [
                            [_vModelText, state.prontuario.receita]
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_49, [
                          _createElementVNode("ul", _hoisted_50, [
                            _createElementVNode("li", _hoisted_51, [
                              _createElementVNode("span", _hoisted_52, _toDisplayString(state.receitaEspecial), 1)
                            ])
                          ]),
                          _withDirectives(_createElementVNode("textarea", {
                            class: "form-control",
                            disabled: "",
                            cols: "1",
                            rows: "6",
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((state.prontuario.receitaEspecial) = $event))
                          }, null, 512), [
                            [_vModelText, state.prontuario.receitaEspecial]
                          ])
                        ])
                      ], 512), [
                        [_vShow, state.campoUnico === true]
                      ])
                    ], 512), [
                      [_vShow, state.mostrarModal]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("button", {
                      class: "btn btn-secondary w-100 mx-0",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (modalResultProntuarios('')))
                    }, "Fechar")
                  ])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["visible"]))
      : _createCommentVNode("", true),
    (state.aguarde)
      ? (_openBlock(), _createBlock(ModalDorape, {
          key: 1,
          title: "Aguarde",
          visible: state.aguarde,
          usarFooter: false,
          usarModal: true,
          larguraMaxima: '10%',
          onModalResult: modalResultProntuarios
        }, {
          default: _withCtx(() => [
            _hoisted_54
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})